import { render } from "./Pill.vue?vue&type=template&id=2b3ec30a&scoped=true"
import script from "./Pill.vue?vue&type=script&lang=ts"
export * from "./Pill.vue?vue&type=script&lang=ts"

import "./Pill.vue?vue&type=style&index=0&id=2b3ec30a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b3ec30a"

export default script